import { render, staticRenderFns } from "./TimeEvents.vue?vue&type=template&id=8be2cef0"
import script from "./TimeEvents.vue?vue&type=script&lang=ts"
export * from "./TimeEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports